import { Component, Input } from '@angular/core';
import { StreamService } from '../../../../service/stream.service';
import { AppdataService } from '../../../../service/appdata.service';

@Component({
  selector: 'rr-track',
  standalone: false,
  templateUrl: './track.component.html',
  styleUrl: './track.component.scss'
})
export class TrackComponent {
  @Input() track: any;
  hidespinner: boolean = true;

  constructor(
    private streamService: StreamService,
    private appData: AppdataService
  ) { }

  async deleteStream(streamId: string) {
    if (this.track.streams.length === 1) {
      let finalDelete = confirm('Are you sure you want to delete this Stream? You will also delete the Track!');
      if (finalDelete) {
        this.hidespinner = false;
        await this.streamService.deleteTrack(this.track.id);
        this.hidespinner = true;
      }
      return;
    }

    let finalDelete = confirm('Are you sure you want to delete this Stream?');
    if (!finalDelete) return;
    this.hidespinner = false;
    let deleteStream = await this.streamService.deleteStream(streamId);
    await this.appData.loadAllTracks();
    this.hidespinner = true;
  }


}
